import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import RenderIf from '../../../shared/render-if/components/render-if';
import CopyButton from '../../../shared/copy-button/components/copy-button';
import b2bConstants from '../constants/b2b-constants';
import constants from '../../../../common/constants';
import { toggleDeactivateKeyModal, revealApiSecret } from '../actions/b2b-actions';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';

import '../../payments/styles/payment-history-table.css';
import '../styles/keys-table.css';

class KeysTable extends Component {
  renderTableHead(items) {
    const { t } = this.context;

    if (items && items.length > 0) {
      return items.map((item, index) => {
        return <th key={index}>{t(item.label)}</th>;
      });
    } else return null;
  }

  renderTableBody(items, generateKeyInProgress, deactivateKeyInProgress, revealApiSecret, keys) {
    const { t } = this.context;

    if (items && items.length) {
      return items.map((item, index) => {
        return (
          <tr key={index} className="payment-history-table-container__table__body__row">
            <td>
              <p>{item.api_key}</p>
              <RenderIf if={!item.is_viewed && !item.api_secret && item.access_mode !== 0}>
                <p className="app-link" onClick={() => revealApiSecret(item.api_key, keys)}>
                  {t('B2B_TABLE.SHOW_SECRET_KEY')}
                </p>
              </RenderIf>
              <RenderIf if={item.is_viewed && item.api_secret}>
                <CopyButton renderInput={true} copyContent={item.api_secret} callback={this.showInfoModal.bind(this)} />
              </RenderIf>
            </td>
            <td>
              <div className="common-switch">
                <RenderIf if={item.access_mode !== 0}>
                  <span className="common-switch__item common-switch__item--active">{t('B2B.ACTIVE')}</span>
                </RenderIf>
                <RenderIf if={item.access_mode === 0}>
                  <span className="common-switch__item common-switch__item--deactive">{t('B2B.INACTIVE')}</span>
                </RenderIf>
              </div>
            </td>
            <td>{item.creation_date ? moment(item.creation_date).format('DD/MM/YYYY') : ''}</td>
            <td onClick={() => this.openDeactivateKeyModal(item)}>
              <div className={`transparent-btn ${item.access_mode === 0 || generateKeyInProgress || deactivateKeyInProgress ? 'transparent-btn-disabled' : ''}`}>{t('B2B_TABLE.DEACTIVATE_BTN')}</div>
            </td>
          </tr>
        );
      });
    } else return null;
  }

  openDeactivateKeyModal(key) {
    if (key && key.access_mode === 0) {
      return;
    }

    const { toggleDeactivateKeyModal } = this.props;

    toggleDeactivateKeyModal(true, key);
  }

  showInfoModal() {
    const { toggleInfoModal } = this.props;

    toggleInfoModal(true, constants.info_modal_types.success.value, 'B2B.API_SECRET_COPY_MESSAGE');
  }

  render() {
    const { keys, generateKeyInProgress, deactivateKeyInProgress, revealApiSecret, passedKeys } = this.props;
    const displayKeys = passedKeys || keys;

    return (
      <div className="keys-table-container">
        <div className="payment-history-table-container table-responsive">
          <table className="payment-history-table-container__table">
            <thead className="payment-history-table-container__table__head">
              <tr className="payment-history-table-container__table__head__row">{this.renderTableHead(b2bConstants.table_columns)}</tr>
            </thead>
            <tbody className="payment-history-table-container__table__body">{this.renderTableBody(displayKeys, generateKeyInProgress, deactivateKeyInProgress, revealApiSecret, keys)}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  keys: state.b2bReducer.keys,
  generateKeyInProgress: state.b2bReducer.generateKeyInProgress,
  deactivateKeyInProgress: state.b2bReducer.deactivateKeyInProgress,
});

const mapDispatchToProps = dispatch => ({
  toggleDeactivateKeyModal: (show, key) => {
    dispatch(toggleDeactivateKeyModal(show, key));
  },
  revealApiSecret: (key, keys) => {
    dispatch(revealApiSecret(key, keys));
  },
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
});

KeysTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(KeysTable);



// WEBPACK FOOTER //
// ./src/app/main/b2b/components/keys-table.js